/**
 * Minimapa.ts — Canvas 2D no canto inferior direito.
 *
 * Renderiza planetas como pontos coloridos + retangulo do viewport da camera.
 * Click no minimapa = teleporta camera.
 * Refator de tres.php:1947-1982.
 */

import { corHex } from '../config';
import type { EstadoJogo } from '../domain/tipos';
import type { Camera } from './Camera';
import type { PixiApp } from './PixiApp';

export class Minimapa {
  private canvas!: HTMLCanvasElement;
  private ctx!: CanvasRenderingContext2D;
  private elContainer!: HTMLElement;

  constructor(
    private readonly pixi: PixiApp,
    private readonly camera: Camera,
    private readonly estado: EstadoJogo,
  ) {}

  iniciar(canvas: HTMLCanvasElement, container: HTMLElement): void {
    this.canvas = canvas;
    this.elContainer = container;
    const ctx = canvas.getContext('2d');
    if (!ctx) throw new Error('canvas 2d context indisponivel');
    this.ctx = ctx;

    // Click teleporta camera
    container.addEventListener('click', (e) => this.onClick(e));

    // Loop proprio (rAF) — independente do Pixi
    requestAnimationFrame(() => this.render());
  }

  private render(): void {
    const ctx = this.ctx;
    const w = this.canvas.width;
    const h = this.canvas.height;

    ctx.fillStyle = 'rgba(10, 16, 32, 0.7)';
    ctx.fillRect(0, 0, w, h);

    // Planetas
    for (const p of this.estado.planetas.values()) {
      const rx = (p.x / this.estado.tamanhoMapa) * w;
      const ry = (p.y / this.estado.tamanhoMapa) * h;
      const rad = Math.max(1.5, (p.raio / this.estado.tamanhoMapa) * w * 4);
      ctx.fillStyle = corHex(p.donoId);
      ctx.beginPath();
      ctx.arc(rx, ry, rad, 0, Math.PI * 2);
      ctx.fill();
    }

    // Viewport (retangulo da camera)
    const vp = this.pixi.viewport;
    const vpw = (vp.w / this.camera.zoom / this.estado.tamanhoMapa) * w;
    const vph = (vp.h / this.camera.zoom / this.estado.tamanhoMapa) * h;
    const vpx = (this.camera.x / this.estado.tamanhoMapa) * w - vpw / 2;
    const vpy = (this.camera.y / this.estado.tamanhoMapa) * h - vph / 2;
    ctx.strokeStyle = 'rgba(255, 255, 255, 0.4)';
    ctx.lineWidth = 1;
    ctx.strokeRect(vpx, vpy, vpw, vph);

    requestAnimationFrame(() => this.render());
  }

  private onClick(e: MouseEvent): void {
    const rect = this.elContainer.getBoundingClientRect();
    const rx = (e.clientX - rect.left) / rect.width;
    const ry = (e.clientY - rect.top) / rect.height;
    this.camera.setAlvo(rx * this.estado.tamanhoMapa, ry * this.estado.tamanhoMapa);
  }
}
